import { TwoColumnLayout } from 'layouts';
import type { EntityOptions, GroupDetail as GroupDetailType } from 'models';
import { GroupPreview } from '../../components';
import type { GroupScope } from '../../models';
import { GroupAdminsCard } from '../group-admins-card';
import { GroupDetailDescription } from '../group-detail-description';
import { GroupHierarchyCard } from '../group-hierarchy-card';

type P = {
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  group: GroupDetailType;
  navigateToGroupEntity: (id: string, scope: GroupScope) => Promise<void>;
};

const GroupDetailAbout = ({ getPathToEntityDetail, group, navigateToGroupEntity }: P) => (
  <TwoColumnLayout
    left={
      <>
        <GroupDetailDescription group={group} />
        <GroupPreview getPathToDetail={getPathToEntityDetail} group={group} navigateToGroups={navigateToGroupEntity} />
      </>
    }
    right={
      <>
        <GroupAdminsCard group={group} />
        <GroupHierarchyCard
          getPathToGroupDetail={(id) => getPathToEntityDetail(id, { entityType: 'group' })}
          group={group}
        />
      </>
    }
  />
);

export default GroupDetailAbout;
